'use client';

import { Loader } from '@googlemaps/js-api-loader';
import { getEnvironmentVariables } from './getEnvironmentVariables';

type Geocoder = google.maps.Geocoder;
export type GeocoderResult = google.maps.GeocoderResult;

let geocodingServiceSingleton: Geocoder | null = null;

const initializeGeocodingService = async (
  apiKey?: string,
): Promise<Geocoder | null> => {
  const envVars = getEnvironmentVariables();
  if (!geocodingServiceSingleton && typeof window !== 'undefined') {
    const loader = new Loader({
      apiKey: apiKey ?? envVars.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? '',
      version: 'weekly',
      libraries: ['places'],
    });
    const importedService = await loader.importLibrary('geocoding');
    geocodingServiceSingleton = new importedService.Geocoder();
  }
  return geocodingServiceSingleton;
};

type GeocoderRequest = google.maps.GeocoderRequest;

interface ExtendedGeocoderRequest extends GeocoderRequest {
  location?: {
    lat: number;
    lng: number;
  };
}

export const geocode = async (
  request: ExtendedGeocoderRequest,
  apiKey?: string,
): Promise<GeocoderResult[]> => {
  const service = await initializeGeocodingService(apiKey);
  if (service) {
    const results = await service.geocode({
      ...request,
      componentRestrictions: { country: 'US' },
    });
    return results.results;
  }
  return Promise.resolve([]);
};
